import { render, staticRenderFns } from "./EventEmployee.vue?vue&type=template&id=4c2bb28e&scoped=true"
import script from "./EventEmployee.vue?vue&type=script&lang=js"
export * from "./EventEmployee.vue?vue&type=script&lang=js"
import style0 from "./EventEmployee.vue?vue&type=style&index=0&id=4c2bb28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2bb28e",
  null
  
)

export default component.exports